import { Component, OnInit, Inject } from "@angular/core";
import {
  MatSnackBarRef,
  MAT_SNACK_BAR_DATA,
} from "@angular/material/snack-bar";

@Component({
  selector: "app-multipleerrormessage",
  templateUrl: "./multipleerrormessage.component.html",
  styleUrls: ["./multipleerrormessage.component.scss"],
})
export class MultipleerrormessageComponent implements OnInit {
  constructor(
    public snackBarRef: MatSnackBarRef<MultipleerrormessageComponent>,
    @Inject(MAT_SNACK_BAR_DATA) public data: any,
  ) {}
  ngOnInit(): void {}
}
